export default {"src":"/_next/static/image/public/images/ic_calendar_white_vertical_menu.9000912722b2ca9bba2b12e54d15b781.svg","height":20,"width":20};